export default function blogFeed() {
  return {
    _id: false,
    type: 'droplet.blogFeed',
    sort: 'newest',
    filters: [],
    match: 'all',
    itemCount: 3,
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/blog-feed/droplet.schema.js